import {
  canAccessPortalArea,
  type AuthorizationSubject,
  type PortalCapabilityAction,
} from "@whitehaven/permissions";

export function canAccessAdminConversationInbox(
  subject: AuthorizationSubject | null,
  action: PortalCapabilityAction = "view",
): boolean {
  return (
    subject !== null &&
    (canAccessPortalArea(subject, "admin-conversations", action) ||
      canAccessPortalArea(subject, "staff-conversations", action))
  );
}

export function adminConversationAuthorizationKey(
  subject: AuthorizationSubject,
): string {
  return JSON.stringify({
    userId: subject.userId,
    roles: [...subject.roles].sort(),
    permissions: [...subject.permissions].sort(),
    locationIds: [...subject.locationIds].sort(),
  });
}
